import React from 'react';
import PropTypes from 'prop-types';
import {COMPONENT_TYPE} from '@learningblocks/exp-constants/lib/Utilities';
import {Button} from '@learningblocks/storybook-components';

/**
 * SubmitButton for the Question footer component;
 */
export function SubmitButton(props) {
  const onSubmit = () => {
    const {componentID, componentType} = props;
    props.submitAnswer(componentID, componentType);
  };

  return (
    <Button onClick={onSubmit} disabled={props.disabled}>
      Submit answer
    </Button>
  );
}

SubmitButton.propTypes = {
  /**
   * The unique id for the question component
   */
  componentID: PropTypes.number,
  /**
   * String for the component Type
   */
  componentType: PropTypes.oneOf([
    COMPONENT_TYPE.CSCQ,
    COMPONENT_TYPE.MSCQ,
    COMPONENT_TYPE.DDQ,
    COMPONENT_TYPE.DNDQ_COLOR,
    COMPONENT_TYPE.GROUPED_DNDQ,
    COMPONENT_TYPE.CSCQ_COLOR,
  ]),
  /**
   * Boolean value controlling button enabled/disabled
   */
  disabled: PropTypes.bool.isRequired,
  /**
   * Callback function involked when Answer submitted
   */
  submitAnswer: PropTypes.func.isRequired,
};
